/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Heading1Inputs */

const zh_landing_admin_heading1 = /** @type {(inputs: Landing_Admin_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教书育人很有意义。`)
};

const en_landing_admin_heading1 = /** @type {(inputs: Landing_Admin_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching is rewarding.`)
};

const es_landing_admin_heading1 = /** @type {(inputs: Landing_Admin_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseñar es gratificante.`)
};

/**
* | output |
* | --- |
* | "Teaching is rewarding." |
*
* @param {Landing_Admin_Heading1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_admin_heading1 = /** @type {((inputs?: Landing_Admin_Heading1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Heading1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_heading1(inputs)
	if (locale === "en") return en_landing_admin_heading1(inputs)
	return es_landing_admin_heading1(inputs)
});